// extracted by mini-css-extract-plugin
module.exports = {"table":"DependencyTable_table__1kVAB","overflowContainer":"DependencyTable_overflowContainer__28vr5","textContainer":"DependencyTable_textContainer__1RBYL"};